// extracted by mini-css-extract-plugin
export var container = "divide-module-card-module--container--2ZPRR";
export var btnContainer = "divide-module-card-module--btnContainer--138AK";
export var divideChildren = "divide-module-card-module--divideChildren--1iNUv";
export var btnTitleFont = "divide-module-card-module--btnTitleFont--3yWPK";
export var cardTitleFont = "divide-module-card-module--cardTitleFont--2kzLA";
export var divide = "divide-module-card-module--divide--VWX1h";